<template>
  <div class="formPosition">
    <template>
      <v-container class="grey lighten-5">
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row no-gutters>
          <v-col md="9">
            <span>Escolhe a classe </span>

            <v-icon large color="green darken-2">forward</v-icon>

            <div class="text-center">
              <v-btn
                :disabled="d10"
                @click="classe(1)"
                class="ma-2"
                outlined
                color="indigo"
                ><v-icon small color="primary">filter_1</v-icon> 10ª
                classe</v-btn
              >
              <v-btn
                :disabled="d11"
                @click="classe(2)"
                class="ma-2"
                outlined
                color="indigo"
                ><v-icon small color="primary">filter_2</v-icon> 11ª
                classe</v-btn
              >
              <v-btn
                :disabled="d12"
                @click="classe(3)"
                class="ma-2"
                outlined
                color="indigo"
                ><v-icon small color="primary">filter_3</v-icon> 12ª
                classe</v-btn
              >
              <v-btn
                :disabled="d13"
                @click="classe(4)"
                class="ma-2"
                outlined
                color="indigo"
                ><v-icon small color="primary">filter_4</v-icon> 13ª
                classe</v-btn
              >
              <v-btn
                v-if="role === 'ROLE_ADM' || role === 'ROLE_PED' || role === 'ROLE_DIR'"
                @click="EstudantesFinalistas()"
                class="ma-2"
                outlined
                color="indigo"
                >Finalistas antigos (antes do sistema)
              </v-btn>
            </div>
          </v-col>

          <v-col md="2">
            <v-select
            v-if="Listaranoslectivo.length>=1 && temMaisDeUmDado(Listaranoslectivo)"
              :items="Listaranoslectivo"
              v-model="anolectivoSelected"
              item-value="descricao"
              item-text="novadescricao"
              label="Selecione o Ano lectivo"
              @change="filtrarAnoLectivo()"
              return-object
            ></v-select>
          </v-col>
          <v-col md="1">
            <v-btn to="/estudante/menu" color="blue" fab small>
              <v-icon small color="white">arrow_back</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "../../plugins/axios";
const ls = require("local-storage");
export default {
  data: () => ({
    constrolo_estudantes_instituicao: [],
    constrolo_estudantes_instituicaoFiltred: [],
    Listaranoslectivo: [],
    anolectivoSelected: ls.get("anolectivo"),
    actividades: [],
    overlay: false,
    d10: true,
    d11: true,
    d12: true,
    d13: true,
    iskilamba: false,
    instituicao: ls.get("i_id"),
  }),
  computed: {
    idclasse() {
      return this.$store.state.idclasse;
    },

    ListaActividades() {
      return ls.get("lista_actividades");
    },
    Instituicao() {
      return ls.get("i_id");
    },
    role() {
      return ls.get("role");
    },
  },

  created() {
    this.Initialize();
    this.initializeAnosLectivo();
    if (window.location.host.includes("localhost")) {
      this.iskilamba = true;
    } else if (window.location.host.includes("eftsk")) {
      this.iskilamba = true;
    } else if (window.location.host.includes("eftsl")) {
      this.iskilamba = false;
    }
    this.$store.state.idclasse = null;
  },

  methods: {
    classe(idclasse) {
      this.$store.state.isloading = true;
      this.$store.state.idclasse = idclasse;
      this.$store.state.anolectivoSelected = this.anolectivoSelected;
      this.constrolo_estudantes_instituicaoFiltred =
        this.constrolo_estudantes_instituicao.filter(
          (c) => parseInt(c.anoacademico) === parseInt(idclasse)
        );
      this.$store.state.config_estudante_instituicao =
        this.constrolo_estudantes_instituicaoFiltred;
      if (
        this.iskilamba &&
        (this.instituicao === 1 || this.instituicao === 5)
      ) {
        /** Estudantes do Kilamba e instituicao (1 e 5) */
        this.$router.push("/estudante/listagem");
      } else {
        this.$router.push("/estudante/listagem");
      }

      //  this.$store.dispatch('setidclasse', idclasse)
    },

    async filtrarAnoLectivo() {
      try {
        this.overlay = true;
        this.constrolo_estudantes_instituicao = await axios
          .post("/Config_instituicao_estudantes", {
            anolectivo: this.anolectivoSelected.descricao,
          })
          .then((res) => res.data);
        this.overlay = false;
      } catch (error) {
        this.overlay = false;
        Swal.fire(
          "Informação",
          "Ocorreu um erro no carregamento das estatísticas de cadastramento",
          "error"
        );
      }
    },

    async Initialize() {
      try {
        this.CarregActividades();
        this.constrolo_estudantes_instituicao = await axios
          .post("/Config_instituicao_estudantes", {
            anolectivo: this.anolectivoSelected,
          })
          .then((res) => res.data);
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro no carregamento das estatísticas de cadastramento",
          "error"
        );
      } finally {
        this.overlay = false;
      }
    },

    async initializeAnosLectivo() {
      try {
        this.Listaranoslectivo = await axios
          .get("/listarAnoLectivoAllCadastroEstudante")
          .then((res) => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.overlay = false;
      }
    },

    async CarregActividades() {
      try {
        let actividades = await axios
          .get("/listAberturaFechoInstituicao")
          .then((res) => res.data);
        if (actividades.length) {
          let d10 = actividades.filter(
            (a) => a.descricao === "Inscrições 10" && a.status_2 === 1
          );
          let d11 = actividades.filter(
            (a) => a.descricao === "Inscrições 11" && a.status_2 === 1
          );
          let d12 = actividades.filter(
            (a) => a.descricao === "Inscrições 12" && a.status_2 === 1
          );
          let d13 = actividades.filter(
            (a) => a.descricao === "Inscrições 13" && a.status_2 === 1
          );

          if (d10.length) {
            this.d10 = false;
          } else this.d10 = true;
          if (d11.length) {
            this.d11 = false;
          } else this.d11 = true;
          if (d12.length) {
            this.d12 = false;
          } else this.d12 = true;
          if (d13.length) {
            this.d13 = false;
          } else this.d13 = true;
        }
      } catch (error) {}
    },
    EstudantesFinalistas() {
      this.$router.push("/estudante/solicitar-certificao-fora-epoca");
    },
    temMaisDeUmDado(array) {
      const objetosComDados = array.filter(obj => Object.keys(obj).length > 0);
      return objetosComDados.length > 1;

},
  },
};
</script>
